import { Controller } from "@hotwired/stimulus"

// Closes a <details> menu on a click outside it or on Escape (it opens and works without JavaScript).
export default class extends Controller {
  connect() {
    this.close = this.close.bind(this)
    document.addEventListener("click", this.close)
    document.addEventListener("keydown", this.close)
    document.addEventListener("turbo:before-cache", this.close)
  }

  disconnect() {
    document.removeEventListener("click", this.close)
    document.removeEventListener("keydown", this.close)
    document.removeEventListener("turbo:before-cache", this.close)
  }

  close(event) {
    if (event.type === "keydown" && event.key !== "Escape") return
    if (event.type === "click" && this.element.contains(event.target)) return
    this.element.open = false
  }
}
